const faqs = [
    {
        question: "How can I make a reservation?",
        answer: "To make a reservation, simply visit our website, choose your desired dates, select a room type, and follow the easy steps to complete the booking process.",
    },

    {
        question: "Is it possible to cancel a reservation?",
        answer: "Yes, you can cancel your reservation through our online platform. Please refer to our cancellation policy for any applicable charges or restrictions.",
    },

    {
        question: "What payment methods are accepted for hotel bookings?",
        answer: "We accept a variety of payment methods, including major credit cards and online payment platforms. You can view the accepted payment options during the booking process.",
    },

    {
        question: "Do you offer special rates for group bookings or events?",
        answer: "Yes, we provide special rates for group bookings and events. Please contact our dedicated group reservations team for personalized assistance and competitive group rates.",
    },

    {
        question: "Can I request additional amenities?",
        answer: "Regrettably, our current operational setup limits our ability to fulfill additional amenity requests or accommodate special arrangements beyond what is outlined during the booking process. It depends on the hotel management.",
    },

    {
        question: "What is your policy on pets?",
        answer: "We understand the importance of furry friends. Some of our properties are pet-friendly, while others may have specific policies. Please check the individual hotel's pet policy or contact us for details.",
    },

    {
        question: "How do I retrieve my booking confirmation?",
        answer: "Once your reservation is confirmed, you will receive an email with the booking details and confirmation number. You can also log in to your account on our website to access and print your confirmation.",
    },
];

export default faqs;
